export default __webpack_public_path__ + "static/4-82182ae9648b42f718d2dd7228279996.jpg";